export const onboardingRoutes = [
  {
    name: 'onboarding',
    path: '/onboarding',
    component: () => import('@/modules/onboarding/views/OnboardingView.vue')
  }
]
